function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
  FutureSlotsControllerOld.$inject = ["$rootScope", "$location", "$timeout", "API_URL", "$http", "$filter"];
  angular.module('calendarApp').controller('FutureSlotsControllerOld', FutureSlotsControllerOld);

  function FutureSlotsControllerOld($rootScope, $location, $timeout, API_URL, $http, $filter) {
    var future = this;

    function init() {
      moment.tz.setDefault(smooth.timeSettings.timezone);
      future.futureDays = []; // Set up future weeks dropdown

      for (var i = 1; i <= smooth.calendarSettings.bookfuturedays; i++) {
        future.futureDays.push(i);
      }

      future.timeSettings = smooth.timeSettings;
      future.selectedSlots = [];
      var storageAppointments = localStorage.getItem('reserved-appointments'),
          customer = $rootScope.customerInfo;

      if (!storageAppointments || !customer) {
        $location.path('/');
        return;
      }

      var reservedAppointments = JSON.parse(storageAppointments);

      if (!Array.isArray(reservedAppointments)) {
        $rootScope.throbber.showError('Sorry but an error has occurred. Please contact support@smoothbook.co');
        $timeout(function () {
          $rootScope.throbber.hide();
          $location.path('/');
        }, 3000);
        return;
      }

      future.selectedSlots = reservedAppointments; // Keep track of new and existing appointments as the new ones will have to be saved.

      future.existingAppointments = angular.copy(reservedAppointments);
      future.newAppointments = []; // Check that appointments have not expired

      if (!reservedAppointments.length || moment().isAfter(moment(reservedAppointments[0].expiry))) {
        localStorage.removeItem('reserved-appointments');
        $location.path('/');
        return;
      }

      future.isWorkshop = !!reservedAppointments[0].workshopshiftid; // We need to get a list of future available timeslots
      // Just get timeslots with the same service and resource, start date is the day after the first appointment's date

      var params = {
        serviceid: reservedAppointments[0].serviceid._id,
        daystocount: smooth.calendarSettings.bookfuturedays,
        startdate: moment(reservedAppointments[0].date).add(1, 'days').format('YYYY-MM-DD')
      }; // If a workshop is being reserved, retrieve *only* timeslots for that shift.

      if (reservedAppointments[0].workshopshiftid) {
        params = _objectSpread({}, params, {
          shiftid: reservedAppointments[0].workshopshiftid
        });
      }

      if (reservedAppointments[0].resourceid) {
        params.resourceid = reservedAppointments[0].resourceid._id;
      } else {
        params.hasresource = false;
      }

      $rootScope.throbber && $rootScope.throbber.show();
      $http.get(API_URL + '/api/v1/calendar/timeslots/' + smooth.orgid, {
        params: params
      }).then(function (reply) {
        $rootScope.throbber && $rootScope.throbber.hide();
        var response = reply.data;

        if (!response.success) {
          $rootScope.throbber.showError(response.msg);
          return;
        }

        if (!response.timeslots || !response.timeslots.length) {
          $location.path('/review');
          return;
        }

        future.shifts = [];
        response.timeslots.forEach(function (day) {
          for (var i = 0; i < day.shifts.length; i++) {
            var shift = day.shifts[i];
            shift.start = shift.timeslots[0].start;
            shift.end = shift.timeslots[shift.timeslots.length - 1].end;

            for (var j = 0; j < shift.timeslots.length; j++) {
              shift.timeslots[j].selected = 0;
            }

            future.shifts.push(shift);
          }
        });
        console.log(future.shifts);
      }, function (error) {
        console.error('ALARM!!');
        console.error(error);
      });
    }

    init();

    future.addTimeslot = function ($shiftIndex, $index) {
      if (future.shifts[$shiftIndex].timeslots[$index].selected === future.shifts[$shiftIndex].bookmulti) {
        return;
      }

      future.shifts[$shiftIndex].timeslots[$index].selected = future.shifts[$shiftIndex].timeslots[$index].selected ? future.shifts[$shiftIndex].timeslots[$index].selected + 1 : 1;
      future.selectedSlots.push($index);
      var key = $shiftIndex + '_' + $index;
      var timeslot = future.shifts[$shiftIndex].timeslots[$index],
          newAppointment = {
        start: timeslot.start,
        end: timeslot.end,
        serviceid: timeslot.serviceid,
        hasresource: timeslot.hasresource,
        resourceid: timeslot.resourceid
      };
      newAppointment.key = key;
      newAppointment.shiftid = future.shifts[$shiftIndex]._id;

      if (future.shifts[$shiftIndex].isworkshop) {
        newAppointment.workshopshiftid = future.shifts[$shiftIndex]._id;
      }

      newAppointment.date = moment.unix(newAppointment.start).format('YYYY-MM-DD');
      future.newAppointments.push(newAppointment);
    };

    future.removeTimeslot = function ($shiftIndex, $index) {
      future.shifts[$shiftIndex].timeslots[$index].selected = future.shifts[$shiftIndex].timeslots[$index].selected - 1;
      future.selectedSlots.splice(future.selectedSlots.indexOf($index), 1);

      for (var i = 0; i < future.newAppointments.length; i++) {
        if (future.newAppointments[i].key === $shiftIndex + '_' + $index) {
          future.newAppointments.splice(i, 1);
          break;
        }
      }
    };

    future.toggleTimeslots = function (index) {
      $('.shift-id-' + index).find('.choose-timeslots-container').slideToggle();
    };

    future.continue = function () {
      if (!future.newAppointments.length && future.existingAppointments.length) {
        localStorage.setItem('reserved-appointments', JSON.stringify(future.existingAppointments));
        $location.path('/review');
        return;
      }

      $rootScope.throbber.show(); // Must reserve any appointments which have not already been reserved.

      $http.post(API_URL + '/api/v1/calendar/appointment/reserve', {
        appointments: future.newAppointments
      }).then(function (reply) {
        $rootScope.throbber.hide();
        var response = reply.data;

        if (!response.success) {
          $rootScope.throbber.showError('An error occurred: ' + response.msg);
          return;
        }

        future.existingAppointments = future.existingAppointments.concat(response.appointments);
        var appointments = JSON.stringify(future.existingAppointments);
        localStorage.setItem('reserved-appointments', appointments); // Show any overbooked timeslots

        if (response.overbooked) {
          $rootScope.overBooked = [];
          $rootScope.overBooked = response.overbookedappointments;
          $location.path('/overbooked/futureslots');
          return;
        }

        $location.path('/review');
      }).catch(function (err) {
        console.error(err);
        $rootScope.throbber.showError('An error occurred: ' + err);
      });
    };

    future.bookFutureWeeks = function () {
      // Build a list of appointments. Should just be able to take the existing ones and add however many weeks
      var newAppointments = [];
      future.existingAppointments.forEach(function (appointment) {
        for (var i = 1; i <= future.bookFutureDays; i++) {
          var newAppointment = angular.copy(appointment);
          delete newAppointment._id;
          newAppointment.start = moment.unix(appointment.start).add(i, 'weeks').unix();
          newAppointment.end = moment.unix(appointment.end).add(i, 'weeks').unix();
          newAppointment.date = moment.unix(newAppointment.start).format('YYYY-MM-DD');
          newAppointment.serviceid = newAppointment.serviceid._id;

          if (newAppointment.resourceid) {
            newAppointment.resourceid = newAppointment.resourceid._id;
          } else {
            newAppointment.hasresource = false;
          }

          if (shift.isworkshop) {
            appointment.workshopshiftid = shift._id;
          }

          newAppointments.push(newAppointment);
        }
      });
      $http.post(API_URL + '/api/v1/calendar/appointment/reserve', {
        appointments: newAppointments
      }).then(function (reply) {
        $rootScope.throbber.hide();
        var response = reply.data;

        if (!response.success) {
          $rootScope.throbber.showError("Sorry but an error occurred: ".concat(response.msg));
          console.error(response.msg);
          return;
        } // Shouldn't happen


        if (!response.appointments || !response.appointments.length) {
          return;
        }

        future.existingAppointments = future.existingAppointments.concat(response.appointments);
        future.selectedSlots = future.existingAppointments;
        var appointments = JSON.stringify(future.existingAppointments);
        localStorage.setItem('reserved-appointments', appointments); // Show any overbooked timeslots

        if (response.overbooked) {
          $rootScope.overBooked = [];
          $rootScope.overBooked = response.overbookedappointments;
          $location.path('/overbooked/futureslots');
          return;
        }
      });
    };

    future.addToWaitlist = function (timeslot) {
      console.log(timeslot); // const timeslot = choose.shift.timeslots[$index];
      // choose.waitlistModal(timeslot, choose.shift);
    };

    future.cancel = function () {
      var cancelMessage = $filter('calendarLabel')('This will remove your reserved appointments. Continue?');

      if (!confirm(cancelMessage)) {
        return;
      }

      $location.path('/');
    };
  }
})();